
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Card, Button, Form } from "react-bootstrap";
import axios from 'axios';
import AdminDashboardLayout from "../../../Components/AdminDashboard/AdminDashboardLayout";
import Loading from 'react-fullscreen-loading';
import { toast } from "react-hot-toast";
import Select from 'react-select'
import UserSelector from "../../../Components/UserSelector/UserSelector";


export default function AddLicense() {
  const navigate = useNavigate();
  const [screenloader, setScreenloader] = useState(false);
  const [userId, setUserId] = useState(null);
  const [noOfLicenses, setNoOfLicenses] = useState(1);
  // const [pid, setPid] = useState("");
  const [licenseRefId, setLicenseRefId] = useState("0000");
  const [userError, setUserError] = useState("");
  // const [pidError, setPidError] = useState("");
  const [licenseRefIdError, setLicenseRefIdError] = useState("");
  const [noOfLicensesError, setNoOfLicensesError] = useState("");

  const [product, setProduct] = useState({});
  const [productError, setProductError] = useState("");
  const [notifyCustomer, setNotifyCustomer] = useState(true);

  const DURATION_UNIT_OPTIONS = [
    { value: "days",   label: "Days" },
    { value: "months", label: "Months" },
    { value: "years",  label: "Years" },
  ];
  const [durationValue, setDurationValue] = useState(1);
  const [durationUnit, setDurationUnit] = useState(DURATION_UNIT_OPTIONS[2]);
  const [durationError, setDurationError] = useState("");

  const AddLicense = async () => {
    await axios.post(`${process.env.REACT_APP_API_URL}/admin/licenses`, {
      user_id: userId,
      no_of_licenses: noOfLicenses,
      license_ref_id: licenseRefId,
      product: product.value,
      duration_value: durationValue,
      duration_unit: durationUnit.value,
      notify_customer: notifyCustomer,
    }, {
      headers: {
        'access-token': localStorage.getItem('accessToken'),
      }
    })
      .then(res => {
        setTimeout(() => {
          setScreenloader(false);
        }, 1500)
        if (res.data.status) {
          toast.success(res.data.message || 'License has been added');
          navigate('/Admin/Licenses');
          return;
        }
        else if (res.data.status === false) {
          toast.error(res.data.message || "Unable to create license");
          return;
        }
        else {
          toast.error('Something Went Wrong');
          console.log(res.data);
          return;
        }
      })
      .catch(er => {
        setScreenloader(false);
        if (er.response.data?.message) {
          toast.error(er.response.data?.message);
          return;
        } else {
          console.log(er);
          toast.error("Something Went Wrong");
          return;
        }
      })
  }


  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setUserError("");
    setLicenseRefIdError("");
    setNoOfLicensesError("");

    // Validation checks
    let isValid = true;

    if (!userId) {
      setUserError("Please select a user");
      isValid = false;
    }

    if (!/^\d{4}$/.test(licenseRefId)) {
      setLicenseRefIdError("License Ref Id must be exactly 4 digits");
      isValid = false;
    }

    if (noOfLicenses < 1) {
      setNoOfLicensesError("No of License must be greater than 0");
      isValid = false;
    }
    if (noOfLicenses > 10) {
      setNoOfLicensesError("You can only add 10 licenses at a time");
      isValid = false;
    }

    const dv = parseInt(durationValue, 10);
    if (!dv || dv < 1) {
      setDurationError("Duration must be at least 1");
      isValid = false;
    } else if (!durationUnit?.value) {
      setDurationError("Select a duration unit");
      isValid = false;
    }

    if (isValid) {
      setScreenloader(true);
      await AddLicense();
    }
  }
  const labelStyles = {
    fontWeight: "bold",
    fontSize: "14px",
  };
  return (
    <div>
      <AdminDashboardLayout />
      <Loading loading={screenloader} background="#fff" loaderColor="#883484" />
      <div className='content-page-bg'>
        <div className='content-page'>
          <div className='content'>
            <h2>Add License</h2>
            <p className="text-muted">Licenses will be added for the selected user with the selected duration.</p>
            <Container fluid className='behind'>
              <Card className='mt-4'>
                <Card.Body>
                  <form onSubmit={handleFormSubmit}>
                    <div className="col-md-4">
                      <div className="mb-3">
                        <label htmlFor="email" className="form-label" style={labelStyles}>
                          User
                        </label>
                        <UserSelector
                          type="user"
                          onSelectUser={(id) => { setUserId(id); setUserError(""); }}
                        />
                        {userError && <div className="d-flex invalid-feedback" style={{ display: 'block' }}>{userError}</div>}
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="mb-3">
                        <label htmlFor="licenseRefId" className="form-label" style={labelStyles} >
                          License Ref Id
                        </label>
                        <input
                          type="text"
                          inputMode="numeric"
                          maxLength={4}
                          className="form-control"
                          id="licenseRefId"
                          placeholder='Your License Ref Id'
                          value={licenseRefId}
                          onChange={(e) => { setLicenseRefId(e.target.value); setLicenseRefIdError(""); }}
                        />
                        {licenseRefIdError && <div className="d-flex invalid-feedback">{licenseRefIdError}</div>}
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="mb-3">
                        <label htmlFor="noOfLicenses" className="form-label" style={labelStyles} >
                          No of Licenses
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          id="noOfLicenses"
                          placeholder='No of Licenses'
                          value={noOfLicenses}
                          onChange={(e) => { setNoOfLicenses(e.target.value); setNoOfLicensesError(""); }}
                        />
                        {noOfLicensesError && <div className="d-flex invalid-feedback">{noOfLicensesError}</div>}
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="mb-3">
                        <label htmlFor="product" className="form-label" style={labelStyles}>
                          Product
                        </label>
                        <Select
                          placeholder="Select Product"
                          options={[
                            { value: "SPCAD_ACAD_Beta", label: "SPCAD_ACAD_Beta" },
                            { value: "SPCAD_GSTARCAD", label: "SPCAD_GSTARCAD" },
                            { value: "SPCAD_BRX", label: "SPCAD_BRX" },
                            { value: "SPCAD_ZWCAD", label: "SPCAD_ZWCAD" },
                            { value: "SPCAD_CADMATE", label: "SPCAD_CADMATE" },
                            { value: "SPCAD_PCAD", label: "SPCAD_PCAD" },
                          ]}
                          value={product}
                          onChange={(selectedOption) => {
                            setProduct(selectedOption);
                            setProductError(""); // Clear the error when a new option is selected
                          }}
                        />
                        {productError && <div className="d-flex invalid-feedback">{productError}</div>}
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="mb-3">
                        <label className="form-label" style={labelStyles}>
                          Duration
                        </label>
                        <div className="d-flex gap-2">
                          <input
                            type="number"
                            className="form-control"
                            id="durationValue"
                            min="1"
                            style={{ maxWidth: 110 }}
                            value={durationValue}
                            onChange={(e) => { setDurationValue(e.target.value); setDurationError(""); }}
                          />
                          <div style={{ flex: 1 }}>
                            <Select
                              options={DURATION_UNIT_OPTIONS}
                              value={durationUnit}
                              onChange={(selectedOption) => {
                                setDurationUnit(selectedOption);
                                setDurationError("");
                              }}
                            />
                          </div>
                        </div>
                        {durationError && <div className="d-flex invalid-feedback" style={{ display: 'block' }}>{durationError}</div>}
                      </div>
                    </div>
                    <div className="col-md-8">
                      <div className="mb-3">
                        <Form.Check
                          type="switch"
                          id="notify-customer-license-switch"
                          label="Email customer that their license has been activated"
                          checked={notifyCustomer}
                          onChange={(e) => setNotifyCustomer(e.target.checked)}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="d-flex flex-column flex-sm-row gap-2 mb-3">
                        <Button className="btn admin-btn" type="submit">
                          Add License
                        </Button>
                        <Button className="btn" style={{ backgroundColor: '#5f75a5ff', color: '#d8d6d6ff', border: 'none' }} onClick={() => navigate(-1)}>
                          Back
                        </Button>
                      </div>
                    </div>
                  </form>
                  <div className="text-muted">
                    <h5>Note:</h5>
                    <p>- Select the registered user the license should be created for.</p>
                    <p>- License Ref id should be 4 digits.</p>
                    <p>- Use 0000 License Ref id to generate a complete 10 digits random id.</p>
                  </div>
                </Card.Body>
              </Card>
            </Container>
          </div>
        </div>
      </div>
    </div>
  );
}
